enum State {
    NOTHING = '',
    HOVER = 'hover:',
    FOCUS = 'focus:',
    ACTIVE = 'active:',
    GROUP_HOVER = 'group-hover:',
    GROUP_FOCUS = 'group-focus:',
    FOCUS_WITHIN = 'focus-within:',
    DISABLED = 'disabled:',
    VISITED = 'visited:',
    CHECKED = 'checked:',
    FIRST = 'first:',
    LAST = 'last:',
    ODD = 'odd:',
    EVEN = 'even:'
}
export default State;